export const SWEETALERT_SET_ALERT = 'SWEETALERT_SET_ALERT';
export const SWEETALERT_HIDE_ALERT = 'SWEETALERT_HIDE_ALERT';
